/* eslint-disable */
// Custom GraphQL queries for enhanced task management

export const getTaskWithDetails = /* GraphQL */ `
  query GetTaskWithDetails($id: ID!) {
    getTask(id: $id) {
      id
      title
      description
      assignedTo
      priority
      status
      area
      estimatedHours
      dueDate
      completedAt
      notes
      category
      assignedUserId
      assignedUser {
        id
        name
        email
        role
        phone
        __typename
      }
      createdBy
      creator {
        id
        name
        email
        role
        __typename
      }
      approvedBy
      approver {
        id
        name
        email
        __typename
      }
      parentTaskId
      parentTask {
        id
        title
        status
        __typename
      }
      templateId
      template {
        id
        name
        category
        instructions
        requiredSkills
        tools
        __typename
      }
      recurring
      recurrencePattern
      nextRecurrence
      tags
      customFields
      approvalRequired
      latitude
      longitude
      dependencies {
        items {
          id
          dependencyType
          dependsOnTask {
            id
            title
            status
            priority
            dueDate
            assignedUser {
              id
              name
              __typename
            }
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      dependentTasks {
        items {
          id
          dependencyType
          task {
            id
            title
            status
            priority
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      timeLogs {
        items {
          id
          startTime
          endTime
          duration
          description
          breakTime
          isAutoTracked
          location
          user {
            id
            name
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      subtasks {
        items {
          id
          title
          status
          priority
          dueDate
          assignedUser {
            id
            name
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      attachments {
        items {
          id
          fileName
          fileUrl
          fileType
          fileSize
          description
          uploader {
            id
            name
            __typename
          }
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const listTasksByUser = /* GraphQL */ `
  query ListTasksByUser(
    $assignedUserId: ID!
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTasks(
      filter: { assignedUserId: { eq: $assignedUserId } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        priority
        status
        area
        estimatedHours
        dueDate
        completedAt
        category
        assignedUser {
          id
          name
          __typename
        }
        creator {
          id
          name
          __typename
        }
        parentTask {
          id
          title
          __typename
        }
        template {
          id
          name
          __typename
        }
        recurring
        tags
        approvalRequired
        latitude
        longitude
        dependencies {
          items {
            id
            dependencyType
            dependsOnTask {
              id
              title
              status
              __typename
            }
            __typename
          }
          __typename
        }
        timeLogs {
          items {
            id
            duration
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listTasksByStatus = /* GraphQL */ `
  query ListTasksByStatus(
    $status: TaskStatus!
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTasks(
      filter: { status: { eq: $status } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        priority
        status
        area
        estimatedHours
        dueDate
        category
        assignedUserId
        assignedUser {
          id
          name
          role
          __typename
        }
        creator {
          id
          name
          __typename
        }
        approvalRequired
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listTasksByCategory = /* GraphQL */ `
  query ListTasksByCategory(
    $category: TaskCategory!
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(
      filter: { category: { eq: $category } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        priority
        status
        area
        estimatedHours
        dueDate
        category
        assignedUser {
          id
          name
          __typename
        }
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listOverdueTasks = /* GraphQL */ `
  query ListOverdueTasks(
    $today: AWSDate!
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(
      filter: {
        and: [
          { dueDate: { lt: $today } }
          { status: { ne: COMPLETED } }
          { status: { ne: CANCELLED } }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        priority
        status
        area
        dueDate
        category
        assignedUserId
        assignedUser {
          id
          name
          role
          phone
          __typename
        }
        creator {
          id
          name
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listTasksDueToday = /* GraphQL */ `
  query ListTasksDueToday(
    $today: AWSDate!
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(
      filter: {
        and: [
          { dueDate: { eq: $today } }
          { status: { ne: COMPLETED } }
          { status: { ne: CANCELLED } }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        priority
        status
        area
        estimatedHours
        category
        assignedUserId
        assignedUser {
          id
          name
          role
          __typename
        }
        tags
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listActiveTimeLogs = /* GraphQL */ `
  query ListActiveTimeLogs(
    $userId: ID
    $filter: ModelTimeLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeLogs(
      filter: {
        and: [
          { userId: { eq: $userId } }
          { endTime: { attributeExists: false } }
        ]
      }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        taskId
        task {
          id
          title
          category
          __typename
        }
        userId
        user {
          id
          name
          __typename
        }
        startTime
        duration
        description
        isAutoTracked
        location
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listTaskTemplates = /* GraphQL */ `
  query ListTaskTemplates(
    $filter: ModelTaskTemplateFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTaskTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        category
        estimatedHours
        priority
        assignedRole
        area
        recurrencePattern
        customFields
        instructions
        requiredSkills
        tools
        isActive
        createdBy
        creator {
          id
          name
          __typename
        }
        tasks {
          items {
            id
            title
            status
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getTaskDependencies = /* GraphQL */ `
  query GetTaskDependencies($taskId: ID!) {
    listTaskDependencies(filter: { taskId: { eq: $taskId } }) {
      items {
        id
        dependencyType
        dependsOnTask {
          id
          title
          status
          priority
          dueDate
          assignedUser {
            id
            name
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const getTaskTimeLog = /* GraphQL */ `
  query GetTaskTimeLog(
    $taskId: ID!
    $filter: ModelTimeLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeLogs(
      filter: { taskId: { eq: $taskId } }
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        startTime
        endTime
        duration
        description
        breakTime
        isAutoTracked
        location
        user {
          id
          name
          role
          __typename
        }
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getWorkerProductivityStats = /* GraphQL */ `
  query GetWorkerProductivityStats(
    $userId: ID!
    $startDate: AWSDateTime!
    $endDate: AWSDateTime!
  ) {
    listTasks(
      filter: {
        and: [
          { assignedUserId: { eq: $userId } }
          { createdAt: { between: [$startDate, $endDate] } }
        ]
      }
    ) {
      items {
        id
        title
        status
        priority
        category
        estimatedHours
        dueDate
        completedAt
        timeLogs {
          items {
            duration
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const getTaskAnalytics = /* GraphQL */ `
  query GetTaskAnalytics(
    $startDate: AWSDateTime!
    $endDate: AWSDateTime!
    $filter: ModelTaskFilterInput
  ) {
    listTasks(
      filter: {
        and: [
          { createdAt: { between: [$startDate, $endDate] } }
          $filter
        ]
      }
    ) {
      items {
        id
        title
        status
        priority
        category
        area
        estimatedHours
        dueDate
        completedAt
        assignedUserId
        assignedUser {
          id
          name
          role
          __typename
        }
        timeLogs {
          items {
            duration
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;